import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function IconEye() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function IconEyeOff() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
      <path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c7 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" />
      <path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3 7 10 7a9.74 9.74 0 0 0 5.39-1.61" />
      <line x1="2" x2="22" y1="2" y2="22" />
      <path d="M12 12a3 3 0 1 1-3-3" />
    </svg>
  );
}

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(username, password);
      navigate('/');
    } catch {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="login-page">
      <aside className="login-hero" aria-labelledby="login-hero-title">
        <div className="login-hero__bg" aria-hidden="true" />
        <div className="login-hero__illustration" aria-hidden="true">
          <svg className="login-hero__svg" viewBox="0 0 400 320" xmlns="http://www.w3.org/2000/svg" role="img">
            <title>Abstract agreements and documents</title>
            <defs>
              <linearGradient id="loginHeroGrad" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="rgba(255,255,255,0.12)" />
                <stop offset="100%" stopColor="rgba(15,139,141,0.35)" />
              </linearGradient>
            </defs>
            <rect x="40" y="48" width="220" height="280" rx="8" fill="url(#loginHeroGrad)" stroke="rgba(255,255,255,0.25)" strokeWidth="2" />
            <rect x="72" y="24" width="220" height="280" rx="8" fill="rgba(255,255,255,0.08)" stroke="rgba(255,255,255,0.2)" strokeWidth="2" />
            <rect x="104" y="0" width="220" height="280" rx="8" fill="rgba(255,255,255,0.06)" stroke="rgba(255,255,255,0.35)" strokeWidth="2" />
            <line x1="130" y1="52" x2="290" y2="52" stroke="rgba(255,255,255,0.35)" strokeWidth="3" strokeLinecap="round" />
            <line x1="130" y1="78" x2="260" y2="78" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeLinecap="round" />
            <line x1="130" y1="100" x2="280" y2="100" stroke="rgba(255,255,255,0.2)" strokeWidth="2" strokeLinecap="round" />
            <circle cx="300" cy="220" r="36" fill="var(--accent)" opacity="0.9" />
            <path d="M288 220l10 10 22-26" fill="none" stroke="#fff" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
        <div className="login-hero__content">
          <p className="login-hero__eyebrow">Colan Infotech</p>
          <h1 id="login-hero-title" className="login-hero__title">
            Agreement &amp; Invoice Management
          </h1>
          <p className="login-hero__lead">
            Manage MSAs and SOWs, track milestones, and keep billing aligned in one place.
          </p>
          <ul className="login-hero__list">
            <li>Contract lifecycle &amp; approvals</li>
            <li>Invoices linked to agreements</li>
            <li>Role-based dashboards</li>
          </ul>
        </div>
      </aside>

      <div className="login-form-panel">
        <div className="login-card">
          <h2 className="login-card__title">Sign in</h2>
          <p className="login-card__subtitle">Use your credentials to access the workspace.</p>
          {error && <div className="login-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Username</label>
              <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="Enter username" required autoComplete="username" />
            </div>
            <div className="form-group">
              <label>Password</label>
              <div className="password-field-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(v => !v)}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <IconEyeOff /> : <IconEye />}
                </button>
              </div>
            </div>
            <button type="submit" className="btn btn-primary">Sign In</button>
          </form>
          <div className="login-demo">
            <strong>Demo accounts</strong>
            <div className="login-demo__row"><code>admin</code> / <code>password123</code> <span className="login-demo__role">Admin</span></div>
            <div className="login-demo__row"><code>priya.bd</code> / <code>password123</code> <span className="login-demo__role">BD</span></div>
            <div className="login-demo__row"><code>ravi.acc</code> / <code>password123</code> <span className="login-demo__role">Accounts</span></div>
          </div>
        </div>
      </div>
    </div>
  );
}
